import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');

class CreditInformation {

    async getCreditInformation(customerId){
        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };

        var result = {};

        const requestBody = {
           
            'operatingUnitId': 446,
            'operatingUnitCode': "MKG",
            'customerId': customerId,
            'currencys': [
                {
                    'currencyCode': "MXN",
                  //  'currencyId': 1
                },
                {
                    'currencyCode': "USD",
                  //  'currencyId': 2
                }
            ]
         }  

        let gatewayRequest = {
            "strEndpointName" : "Credito",
            "strMethod" : "POST",
            "strJsonData" : requestBody//,
            //"arrCustomHeaders": []
        }

        await axios.post(APIurl, gatewayRequest, config)
        .then(response => {
            result = JSON.parse(response.data);
        })
        .catch(error => console.error(error));
        return result;
    }
}

module.exports = CreditInformation